<template>
  <div class="container">
    <h1 class="h1">Actual Cost Limits</h1>

    <sdx-loading-spinner v-if="loading" size="large" sr-hint="Loading" class="spinner-dashboard"></sdx-loading-spinner>

    <div v-if="!loading">
      <div v-if="items.length === 0">Keine Cost Limits vorhanden.</div>

      <template v-else>
        <div class="row margin-bottom-1" style="margin-bottom: 16px;">
          <div class="col col-xs-6">
            <div id="barCostLimitNational" data-testid="barCostLimitNational" class="loader-bar">
              <div class="detail" style="vertical-align: bottom;">
                <div class="name cost-limit-bar-title">National</div>
              </div>
            </div>
          </div>
          <div class="col col-xs-6">
            <div id="barCostLimitInternational" data-testid="barCostLimitInternational" class="loader-bar">
              <div class="detail">
                <div class="name cost-limit-bar-title">International</div>
              </div>
            </div>
          </div>
        </div>

        <div class="row margin-bottom-1" v-for="(it, idx) in items" :key="idx" style="margin-bottom: 16px;">
          <div class="col col-xs-6">
            <div id="barCostLimitNational" data-testid="barCostLimitNational" class="loader-bar">
              <div class="detail" style="vertical-align: bottom;">
                <div class="name"><span :title="it.costEmail" class="blue">{{ it.devAppDisplayName }}</span></div>
                <div class="detail-right">
                  <div class="progress">used {{ formatBigNumber(it.actualCostNational) }}</div>
                  <div class="file-size">of {{ formatBigNumber(it.costLimitNational) }} {{ it.getCostUnit }} per {{
                      it.costPeriode
                    }}
                  </div>
                </div>
              </div>
              <div class="loader-bar--progress cost-limit-bar">
                <div class="indicator"
                     :class="(it.actualCostNational>=it.costAlarmNational?(it.actualCostNational>=it.costLimitNational?'cost-limit':'cost-alarm'):'')"
                     :style="'width: '+(it.actualCostNational/it.costLimitNational*100)+'%;'"></div>
              </div>
              <div>
                <span v-if="it.actualCostAlarmNationalSent"
                      class="infoCostAlarm">Alarm: {{ it.actualCostAlarmNationalSent }}<br/></span>
                <span v-if="it.actualCostLimitNationalSent"
                      class="infoCostLimit">Blocked:  {{ it.actualCostLimitNationalSent }}<br/></span>
              </div>
            </div>
          </div>

          <div class="col col-xs-6">
            <div id="barCostLimitInternational" data-testid="barCostLimitInternational" class="loader-bar">
              <div class="detail">
                <div class="name"><span :title="it.costEmail" class="blue">{{ it.devAppDisplayName }}</span></div>
                <div class="detail-right">
                  <div class="progress">used {{ formatBigNumber(it.actualCostInternational) }}</div>
                  <div class="file-size">of {{ formatBigNumber(it.costLimitInternational) }} {{ it.getCostUnit }} per {{
                      it.costPeriode
                    }}
                  </div>
                </div>
              </div>
              <div class="loader-bar--progress cost-limit-bar">
                <div class="indicator"
                     :class="(it.actualCostInternational>=it.costAlarmInternational?(it.actualCostInternational>=it.costLimitInternational?'cost-limit':'cost-alarm'):'')"
                     :style="'width: '+(it.actualCostInternational/it.costLimitInternational*100)+'%;'"></div>
              </div>
            </div>
            <div>
              <div>
                <span v-if="it.actualCostAlarmInternationalSent"
                      class="infoCostAlarm">Alarm: {{ it.actualCostAlarmInternationalSent }}<br/></span>
                <span v-if="it.actualCostLimitInternationalSent"
                      class="infoCostLimit">Blocked:  {{ it.actualCostLimitInternationalSent }}<br/></span>
              </div>
            </div>
          </div>
        </div>

      </template>
    </div>
  </div>
</template>

<script>
import costLimitService from '../service';
import loadingSpinnerService from '@/services/loading-spinner.service';
import {showAlert} from '@/services/notification.service';
import {formatBigNumber} from "@/util/utility";

export default {
  data() {
    return {
      items: [],
      loading: false
    };
  },
  methods: {
    formatBigNumber,
    async loadList() {
      this.loading = true;
      loadingSpinnerService.show('costlimit');
      try {
        const response = await costLimitService.actualCostLimits();
        // response.data erwartet eine Liste im Schema von costLimit.json
        this.items = response.data || [];
      } catch (error) {
        showAlert(error.message || 'Fehler beim Laden der Cost Limits');
      } finally {
        this.loading = false;
        loadingSpinnerService.hide('costlimit');
      }
    },

    // Helpers mit Fallback auf productCostLimit
    actualCostNationalValue(it) {
      return Number(it.actualCostNational ?? 0);
    },
    costLimitNationalValue(it) {
      return Number((it.costLimitNational !== undefined ? it.costLimitNational : (it.productCostLimit ? it.productCostLimit.costLimitNational : 0)) ?? 0);
    },
    costAlarmNationalValue(it) {
      return Number((it.costAlarmNational !== undefined ? it.costAlarmNational : (it.productCostLimit ? it.productCostLimit.costAlarmNational : 0)) ?? 0);
    },
    isNationalByProduct(it) {
      return it.costLimitNational === undefined && it.productCostLimit !== undefined;
    },

    actualCostInternationalValue(it) {
      return Number(it.actualCostInternational ?? 0);
    },
    costLimitInternationalValue(it) {
      return Number((it.costLimitInternational !== undefined ? it.costLimitInternational : (it.productCostLimit ? it.productCostLimit.costLimitInternational : 0)) ?? 0);
    },
    costAlarmInternationalValue(it) {
      return Number((it.costAlarmInternational !== undefined ? it.costAlarmInternational : (it.productCostLimit ? it.productCostLimit.costAlarmInternational : 0)) ?? 0);
    },
    isInternationalByProduct(it) {
      return it.costLimitInternational === undefined && it.productCostLimit !== undefined;
    },

    getCostUnit(it) {
      // productInternal true -> CHF, false -> SMS
      return it.productInternal ? 'CHF' : 'SMS';
    },

    indicatorClass(actual, alarm, limit) {
      if (actual >= limit && limit > 0) return 'cost-limit';
      if (actual >= alarm && alarm > 0) return 'cost-alarm';
      return '';
    },

    percentageNational(item) {
      const limit = this.costLimitNationalValue(item);
      if (!item || limit === 0) return 0;
      const pct = Math.round((Number(this.actualCostNationalValue(item)) / Number(limit)) * 100);
      return pct > 100 ? 100 : pct;
    },

    percentageInternational(item) {
      const limit = this.costLimitInternationalValue(item);
      if (!item || limit === 0) return 0;
      const pct = Math.round((Number(this.actualCostInternationalValue(item)) / Number(limit)) * 100);
      return pct > 100 ? 100 : pct;
    },
    getCostLimitLink(webId) {
      return `/cost/limit?webId=${webId}`;
    }
  },
  mounted() {
    // initial laden
    this.loadList();
  }
};
</script>

<style scoped>
.loader-bar--progress > .indicator {
  height: 40px;
}

.loader-bar--progress > .indicator::after {
  height: 40px;
}

.cost-limit-bar-title {
  font-size: 24px;
  font-weight: bold;
}

.cost-limit-bar {
  height: 40px;
}

.cost-alarm {
  background-color: orange !important;
}

.cost-limit {
  background-color: red !important;
}

.infoCostAlarm {
  color: orange;
}

.infoCostLimit {
  color: red;
}
</style>
